import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  blankState: {
    padding: "60px",
    height: "70vh",
  },
}));

const BlankState = ({ message }) => {
  const classes = useStyles();
  return (
    <div
      className={
        classes.blankState +
        " blank-state-component flex flex-col items-center justify-center"
      }
    >
      <img
        style={{ width: "200px" }}
        src={"/images/empty.svg"}
        alt="empty-box"
      />
      <h2>No results found</h2>
      <p>
        {message ||
          "Try adjusting your search or filter to find what you're looking for."}
      </p>
    </div>
  );
};

export default React.memo(BlankState);
